module.exports = __webpack_public_path__ + "static/media/Step-4-B2C-V_4.1861f03b.png";